import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { PhoneInput } from '@bambi/component-library/src/components/inputs/PhoneInput';
import { isValidPhoneNumber } from 'react-phone-number-input';

import { PayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';
import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import { usePayerTripRequiredField } from './usePayerTripRequiredField';

export function TripBookedBySection({
  selectedPayer,
}: {
  selectedPayer: PayerOrganizationRead | null;
}) {
  const isBookedByNameRequired = usePayerTripRequiredField(
    'booked_by_name',
    selectedPayer
  );

  const isBookedByPhoneNumberRequired = usePayerTripRequiredField(
    'booked_by_phone_number',
    selectedPayer
  );

  return (
    <div className="flex gap-2">
      <div className="grow">
        <FormFieldController
          name={'booked_by_name'}
          rules={{
            required: isBookedByNameRequired
              ? 'Requested By Name is required'
              : undefined,
          }}
        >
          {({ field, fieldState }) => {
            return (
              <FormField
                label="Requested By Name"
                error={fieldState.error?.message?.toString()}
                type="text"
                inputProps={{
                  id: 'booked-by-name',
                  placeholder: 'Name of person requesting trip',
                  ...field,
                }}
              />
            );
          }}
        </FormFieldController>
      </div>
      <div className="grow">
        <FormFieldController
          name={'booked_by_phone_number'}
          rules={{
            required: isBookedByPhoneNumberRequired
              ? 'Requested By Phone Number is required'
              : undefined,
            validate: (value: string) =>
              !value ||
              isValidPhoneNumber(value) ||
              'Please enter a valid phone number',
          }}
        >
          {({ field, fieldState }) => {
            return (
              <div>
                <DefaultFormFieldLayout
                  label="Requested By Phone Number"
                  error={fieldState.error?.message?.toString()}
                  inputId="booked_by_phone_number"
                >
                  <PhoneInput
                    {...field}
                    error={fieldState.error?.message?.toString()}
                    placeholder="(555) 555-5555"
                    dataTestId="phone"
                  />
                </DefaultFormFieldLayout>
              </div>
            );
          }}
        </FormFieldController>
      </div>
      <div className="w-72">
        <FormFieldController name={'booked_by_phone_extension'}>
          {({ field, fieldState }) => {
            return (
              <FormField
                label="Requested By Phone Extension"
                type="text"
                inputProps={{
                  id: 'booked-by-phone-extension',
                  ...field,
                }}
              />
            );
          }}
        </FormFieldController>
      </div>
    </div>
  );
}
